<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <store-form />
      </div>
    </div>
  </section>
</template>

<script>
import storeForm from './Temp/StoreFormTemp.vue'

export default {
  name: 'Tables',
  components: {
    'store-form': storeForm
  },
  methods: {
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  }
}
</script>



// WEBPACK FOOTER //
// CrStore.vue?406ccbb1